<div
    class="forms-submit{{align ? ' -align-'+align : ''}}{{marginTop ? ' -margin-top-'+marginTop : ''}}{{marginBottom ? ' -margin-bottom-'+marginBottom : ''}}{{offsetLeft ? ' -offset-left' : ''}}{{offsetRight ? ' -offset-right' : ''}}">
    <shared-btn (onClick)="handleClick($event)"
        [disabled]="disabled || (parentForm && !parentForm?.valid) || loading === 'loading'" class="forms-submit__btn"
        [form]="formName || null"
        [loading]="loading || (parentForm && (parentForm.statusChanges | async) === 'PENDING')" [left]="left"
        [right]="right" [type]="type" [feel]="feel" [size]="size" [badgeLeft]="badgeLeft" [badgeRight]="badgeRight"
        [badgePosition]="badgePosition" [inverted]="inverted" [tabindex]="tabindex" [iconLeft]="iconLeft"
        [iconRight]="iconRight" [title]="title" [role]="role" [width]="width" [paddings]="paddings" #btn>
        <ng-content></ng-content>
    </shared-btn>
</div>